<template>
  <div
    v-show="isVisible"
    class="zoom-phone-widget"
  >
    <!-- カスタムヘッダー -->
    <div class="widget-header">
      <!-- 閉じるボタン（左側） -->
      <div class="close-button-wrapper">
        <BBtn
          size="small"
          type="white"
          fab
          text
          class="close-button"
          @click="closeWidget"
        >
          <BIcon
            size="small"
            class="close-icon"
          >
            close
          </BIcon>
        </BBtn>
      </div>

      <!-- ログイン情報（中央） -->
      <div class="login-info">
        <span class="login-label">{{ $t('vaApp.zoomPhone.loginLabel') }}</span>
        <span class="client-name">{{ clientName }}</span>
      </div>
    </div>

    <!-- Zoom Phone iframe -->
    <div class="widget-content">
      <iframe
        id="zoom-embeddable-phone-iframe"
        src="https://applications.zoom.us/integration/phone/embeddablephone/home"
        allow="clipboard-read; clipboard-write https://applications.zoom.us"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, onMounted, onUnmounted } from 'vue';
import { useCurrentUserProvider } from '@/composable/current-user';
import { useZoomPhoneForVa } from '@/composable/va-app/zoom-phone-widget/zoom-phone-for-va';
import { ZOOM_PHONE_WIDGET_VISIBLE_KEY } from '@/composable/va-app/zoom-phone-widget/zoom-phone-widget-visible';

const { inject: injectCurrentUser } = useCurrentUserProvider();
const { currentUser } = injectCurrentUser();
const { registerHandlers, unregisterHandlers } = useZoomPhoneForVa();

const zoomPhoneWidgetVisible = inject(ZOOM_PHONE_WIDGET_VISIBLE_KEY);
if (!zoomPhoneWidgetVisible) {
  throw new Error('ZoomPhoneWidget: ZOOM_PHONE_WIDGET_VISIBLE_KEY is not provided');
}
const isVisible = zoomPhoneWidgetVisible;

const clientName = computed(() => currentUser.value?.clientName ?? '不明');

const closeWidget = () => {
  zoomPhoneWidgetVisible.value = false;
};

onMounted(() => {
  // TODO: 次のPRでイベントハンドラ機能を実装
  // Zoom Phone の zp-call-connected-event, zp-call-ended-event を監視して
  // 通話終了後に確認ダイアログを表示する
  registerHandlers();
});

onUnmounted(() => {
  unregisterHandlers();
});
</script>

<style lang="scss" scoped>
$widget-width: 350px;
$widget-height: 650px;
$header-height: 48px;
// 閉じるボタン＋パディングを除いたヘッダー中央テキスト用の最大幅
$login-info-max-width: 270px;

.zoom-phone-widget {
  position: fixed;
  bottom: 92px;
  right: 20px;
  width: $widget-width;
  height: calc(#{$widget-height} + #{$header-height});
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  overflow: hidden;
  // NOTE: 文字起こし画面のローディングのz-index 2000に合わせる
  z-index: 2000;
}

.widget-header {
  width: 100%;
  height: $header-height;
  background: $basecolor-base;
  display: flex;
  align-items: center;
  padding: 0 8px;
  position: relative;
}

.login-info {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: white;
  max-width: $login-info-max-width;
  min-width: 0; // flex で省略表示が効くようにする

  .login-label {
    font-weight: 500;
    flex-shrink: 0;
  }

  .client-name {
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }
}

.widget-content {
  width: 100%;
  height: $widget-height;
  background: #f5f5f5;
  overflow: hidden;
}

#zoom-embeddable-phone-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
